/* istanbul ignore file */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Anchor } from 'framework/ui/Anchor';

type TimelineRecordAnchorProps = {
  timelineId: string | number;
  basePathname?: string;
};

const TimelineRecordAnchor = ({ timelineId, basePathname = '' }: TimelineRecordAnchorProps) => {
  const { pathname } = useLocation();

  const pathnameWithoutEntryId = basePathname || pathname.replace(/\/\d+$/, '');
  const link = `${pathnameWithoutEntryId}/${timelineId}`;

  return (
    <Anchor id={`anchor-entry${timelineId}`} link={link} classes="timeline-anchor">
      Copy link
    </Anchor>
  );
};

export default TimelineRecordAnchor;
